import React from 'react';
import SleekButton from '@/components/ui/NavButtons';

export const DemoSection: React.FC = () => {
  return (
    <section className="relative w-full max-w-7xl mx-auto px-4 py-24">
      {/* Gradient border wrapper */}
      <div className="relative overflow-hidden rounded-3xl p-[1px] bg-gradient-to-r from-blue-600 via-indigo-500 to-blue-600 bg-[length:200%_200%] animate-gradient shadow-[0_0_60px_rgba(59,130,246,0.2)]">
        {/* Inner */}
        <div className="relative dark:bg-gradient-to-br dark:from-vw-highlight/95 dark:via-vw-highlight/90 dark:to-vw-bg/98 bg-gradient-to-br from-white via-blue-50/80 to-indigo-50/60 rounded-3xl px-8 py-14 md:px-14 md:py-16 overflow-hidden">

          {/* Background glows */}
          <div className="absolute inset-0 bg-gradient-to-br dark:from-blue-600/10 from-blue-400/5 via-transparent dark:to-blue-400/10 to-indigo-300/5 rounded-3xl pointer-events-none" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 dark:bg-blue-500/10 bg-blue-300/20 rounded-full blur-3xl pointer-events-none" />

          {/* Content */}
          <div className="relative z-10 flex flex-col items-center text-center max-w-2xl mx-auto">

            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full dark:bg-white/10 bg-blue-100 dark:border dark:border-white/20 border border-blue-200 dark:text-blue-200 text-blue-700 text-xs font-bold tracking-widest uppercase mb-6">
              <span className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse" />
              Free 14-day trial — no commitment
            </div>

            <h2 className="text-3xl md:text-5xl font-extrabold dark:text-white text-gray-900 mb-4 leading-tight">
              Make your next investment decision{' '}
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                with confidence.
              </span>
            </h2>

            <p className="text-base md:text-lg dark:text-white/75 text-gray-600 mb-10 leading-relaxed max-w-lg">
              Stop guessing. Start investing with clarity. See your readiness score, portfolio performance, and lender reports — in under 10 minutes.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 w-full max-w-sm">
              <SleekButton
                variant="primary"
                className="flex-1 w-full justify-center"
                onClick={() => window.open("https://app.vawena.ai/signup", "_self")}
              >
                  Start Free Analysis →
              </SleekButton>
              <SleekButton
                variant="light"
                className="flex-1 w-full justify-center"
                onClick={() => window.open("/contact", "_self")}
              >
                Book a Free Demo
              </SleekButton>
            </div>

            {/* Trust row */}
            <div className="flex flex-wrap justify-center gap-5 mt-8">
              {[
                "No credit card required to start",
                "We'll remind you before you're charged",
                "Cancel anytime",
              ].map((t) => (
                <span key={t} className="flex items-center gap-2 text-xs dark:text-white/50 text-gray-500">
                  <svg className="w-3.5 h-3.5 text-blue-400 shrink-0" viewBox="0 0 14 14" fill="none">
                    <path d="M2.5 7l3.5 3.5 5.5-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
